<template>
  <div class="right-panel">
    <div class="item"
      v-for="(item, index) in data"
      :key="index"
      >
        <div class="bx pointer" @mouseenter="mouseenter(index)" @mouseleave="mouseleave()" @click="clickFn(item)">
          <i class="iconfont size18 marRight5 colorF v-middle" :class="`${item.icon}`"></i>
          <span class="size12 colorF showW v-middle" >{{item.btnName}}</span>
        </div>
    </div>
    <div class="item" v-show="isGoTop">
      <div class="bx pointer" @mouseenter="mouseenter(100)" @mouseleave="mouseleave(100)" @click="GoTop">
        <i class="iconfont icon-zhiding marRight5 colorF v-middle" ></i>
        <span class="size12 colorF showW v-middle" >置顶</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FixedBtn', // 右侧悬浮的按钮
  props: {
    data: {
      type: Array,
      default: () => {
        return [
          // {
          //   btnName: '保存',
          //   icon: 'icon-shenqingshouquan',
          //   clickFn: () => {
          //     console.log('保存')
          //   }
          // }
        ]
      }
    }
  },
  data () {
    return {
      activeIndex: 1000,
      isGoTop: false
    }
  },
  mounted() {
    document.getElementById("boxScroll").addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    document.getElementById("boxScroll").removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    clickFn (item) {
      item.clickFn()
    },
    mouseenter (index) {
      this.activeIndex = index
    },
    mouseleave () {
      this.activeIndex = undefined
    },
    //缓冲返回顶部 使用了H5定时器requestAnimationFrame
    GoTop() {
      let boxScroll = document.getElementById('boxScroll')
      let timer = null,
        _that = this;
      clearInterval(timer);
      timer = setTimeout(function fn() {
        if (_that.scrollTop > 0) {
          let speed = (0 - _that.scrollTop) / 5;
          speed = speed > 0 ? Math.ceil(speed) : Math.floor(speed);
          boxScroll.scrollTop = _that.scrollTop + speed;
          timer = setTimeout(fn);
        } else {
          clearTimeout(timer)
        }
      })
    },
    handleScroll() {
      let boxScroll = document.getElementById('boxScroll')
      this.scrollTop = boxScroll.scrollTop
      // console.log(this.scrollTop)
      if (this.scrollTop > 200) {
        this.isGoTop = true
      } else {
        this.isGoTop = false
      }
    }
  }
}
</script>

<style scoped>
  .right-panel {
    position: fixed;
    right: 10px;
    top: 270px;
    z-index: 5;
  }
  .right-panel .item {
    border-radius: 4px;
    margin-bottom: 10px;
    height: 41px;
    line-height: 41px;
    display: block;
    position: relative;
    width: 200px;
  }
  .right-panel .item .bx {
    border-radius: 4px;
    background: #289EFC;
    display: inline-block;
    padding: 0 15px;
    position: absolute;
    right: 0px;
    top: 0px;
    transition: .3s;
    min-width: 83px;
    text-align: center;
  }
  .right-panel .item .bx:hover{
    background: #53b1fd;
    border-color: #53b1fd;
    color: #fff;
  }
  .showW {
    transition: .3s;
  }
  .icon-none{
    display: none;
  }
  @media screen and (max-width: 1300px) {
    .right-panel .item {
      height: 34px;
      line-height: 33px
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/FixedBtn.vue